'use strict';

var _ = require('./util');
var utilUrl = require('./util-url');

/**
 * @param {Object} options
 */
module.exports = function () {
  var theOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var options = _.extend({
    url: '',
    data: {},
    dataType: 'JSON',
    type: 'GET',
    withCredentials: true,
    timeout: 20000
  }, theOptions);

  options.type = options.type.toUpperCase();
  options.dataType = options.dataType.toUpperCase();

  options.success = function (data, xhr) {
    options.complete && options.complete(data, xhr);
  };

  options.error = function (xhr) {
    options.complete && options.complete({
      networkError: true,
      retcode: xhr._status || xhr.status || 0,
      status: xhr._status || xhr.status || 0
    }, xhr);
  };

  // 适配天璇，天璇项目默认会引入jQuery
  // 只有isUseJQueryAjax传入false时才令ajax为指定的函数，否则走以前的逻辑
  var isUseJQueryAjax = options.isUseJQueryAjax;

  var ajax = isUseJQueryAjax !== false && window.jQuery && jQuery.ajax || function (options) {
    if (options.dataType === 'JSONP') {
      throw new Error('UNSUPPORT JSONP');
    } else {
      _ajax(options);
    }
  };

  // cgiProxy 为 true 的请求类型，不走preload逻辑，
  // 因为preload.get方法会将url拼接的参数追加到options.data里面（有bug），详见@tencent/preload包
  // 导致手Q内cgi.qlive.qq.com的接口的body参数不符合后台检测规则，返回错误
  // 中台挂件和now挂件容器会注入preload脚本，而本地浏览器访问无此问题，如果qlive接口也接入preload方式，再调试preload逻辑
  if (window.Preload && !options.cgiProxy) {
    window.Preload.get(options, function (data, xhr) {
      if (data) {
        setTimeout(function () {
          options.success(data, xhr);
        }, 1);
      } else {
        ajax(options);
      }
    });
  } else {
    ajax(options);
  }
};

function _ajax(options) {
  var host = options.host,
      url = options.url,
      cgiProxy = options.cgiProxy;

  var xhr = new XMLHttpRequest();

  var isQLiveCgi = utilUrl.checkQLiveCgi(host, url);
  if (!isQLiveCgi && !cgiProxy) {
    options.data._ = Math.random();
  }

  function success() {
    try {
      var data = xhr.responseText || '';
      if (options.dataType === 'JSON') {
        data = JSON.parse(data);
      }
      options.success && options.success(data, xhr);
    } catch (e) {
      options.error && options.error(xhr);
    }
  }

  function error() {
    options.error && options.error(xhr);
  }

  // 手动判断timeout
  var checkTimeoutT = setTimeout(function () {
    if (xhr.readyState !== 4) {
      xhr._status = 0; // request timeout
      xhr.abort();
    }
  }, options.timeout);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        success();
      } else {
        error();
      }

      // 此处要clear掉
      if (checkTimeoutT) {
        clearTimeout(checkTimeoutT);
      }
    }
  };

  // 需要额外处理下请求的 url，确保为如下两种写法
  // 无域名形式：/cgi-bin/xxx
  // 有域名形式：https://now.qq.com/cgi-bin/xxx
  var requestUrl = utilUrl.getRequestUrl(url, {
    host: options.host,
    protocol: location.protocol
  });

  if (options.type === 'GET') {
    requestUrl = appendQuery(requestUrl, options.data || {});
    xhr.open('GET', requestUrl, true);
  } else {
    // cgiproxy 不能识别 post body 中的 bkn 参数，需要放到 url query 中
    if (options.data.bkn) {
      requestUrl = appendQuery(requestUrl, { bkn: options.data.bkn });
    }
    // cgiproxy 不能有别的参数，需要删除 body 中的 bkn
    if (cgiProxy && options.data.bkn !== undefined) {
      delete options.data.bkn; // eslint-disable-line no-param-reassign
    }
    xhr.open(options.type || 'POST', requestUrl, true);
  }

  // 2019.02.18
  // 问题：IE10、IE9下，xhr在open之前设置 timeout，导致报错 invalidState
  // 参考链接：https://github.com/airbrake/airbrake-js/issues/302
  //
  // timeout生成无限大
  // xhr timeout触发时error不能判断是因为timeout
  // xhr.timeout = 1000000;
  xhr.timeout = options.timeout;

  try {
    xhr.withCredentials = options.withCredentials;
  } catch (e) {
    // 某些浏览器 xhr 不支持 withCredentials 属性修改
    // {
    //     "code": 11,
    //     "name": "INVALID_STATE_ERR",
    //     "message": "INVALID_STATE_ERR: DOM Exception 11"
    // }
    // alert('_ajax withCredentials catch' + JSON.stringify(e))
  }

  if ((options.contentType || options.type === 'POST') && options.contentType !== 'multipart/form-data') {
    xhr.setRequestHeader('Content-Type', options.contentType || 'application/x-www-form-urlencoded');
  }
  if (options.headers) for (var name in options.headers) {
    xhr.setRequestHeader(name, options.headers[name]);
  }var requestData = options.contentType === 'application/json' ? JSON.stringify(options.data || {}) : _.param(options.data || {});
  if (options.contentType === 'multipart/form-data') {
    requestData = options.data;
  }
  xhr.send(options.type === 'GET' ? null : requestData);
}

function appendQuery(url, data) {
  return !data ? url : url + (url.match(/\?/) ? '&' : '?') + _.param(data);
}